<template>
  <div class="free-shipping">
    <a class="free-shipping-message" @click.prevent="">
      <span class="free-shipping-text">
        <span>Free Shipping</span>
        <span class="af-about-small"></span>
      </span>
    </a>
    <div class="free-shipping-hover">
      {{ message }}
    </div>
  </div>
</template>
<script>
export default {
  props: ['message'],
};
</script>
<style lang="scss">
@import '~@article/pixel/dist/style/variables';
@import '~@article/pixel/dist/style/mixins';

.free-shipping {
  position: relative;

  .free-shipping-message {
    display: inline-block;
    padding: var(--space-1) var(--space-2);
    background-color: var(--coral-light);
    font-size: var(--font-size-12);
    line-height: var(--line-height-12);
    text-transform: uppercase;
    letter-spacing: var(--uppercase-letter-spacing);
  }

  .free-shipping-text {
    display: flex;
    line-height: 1.25em;
    align-items: center;

    & > *:not(:last-child) {
      margin-right: 5px;
      margin-top: 2px;
    }
  }

  .free-shipping-hover {
    display: none;
    position: absolute;
    min-width: 320px;
    max-width: 100%;
    background: $grey-background-color;
    font-size: var(--font-size-12);
    line-height: var(--line-height-12);
    padding: 10px 15px 10px 15px;
    margin-top: 6px;
    z-index: 50;
    @include overlay();

    @media (max-width: $mobile-breakpoint - 1) {
      min-width: 250px;
      right: 0px;
    }

    @media (max-width: $mobile-breakpoint - 1) {
      &:before {
        content: '';
        position: absolute;
        width: 280px;
        height: 6px;
        top: -6px;
        left: 0px;
      }
    }

    @media (min-width: $mobile-breakpoint) {
      left: 0px;

      &:before {
        content: '';
        position: absolute;
        width: 350px;
        height: 6px;
        top: -6px;
        left: 0px;
      }
    }
  }

  &:hover {
    .free-shipping-hover {
      display: block;
    }
  }
}
</style>
